import getConfig from "next/config";
import Heading from "@components/Heading";
const {
  publicRuntimeConfig: {
    content: { websiteTitle },
    settings: { websiteName, cdn, websiteStatics },
  },
} = getConfig();

const mainContent = (
  <div className="mb-10">
    {websiteName === "altex" && (
      <>
        <p className="mb-4">
          De 30 de ani alaturi de romani, Altex este liderul pietei locale de
          electro-IT si spune una dintre povestile de succes ale
          antreprenoriatului romanesc.
        </p>

        <p className="mb-4">
          Conceptul omnichannel ofera clientilor posibilitatea de a achizitiona
          atat online, cat si offline, produse de calitate adecvate nevoilor
          tuturor tipurilor de consumatori.
        </p>

        <p className="mb-4">
          In prezent, in Grupul Altex, suntem aproximativ 4.000 de persoane si
          ne desfasuram activitatea intr-un mediu dinamic, cu focus atat pe
          nevoile clientilor, cat si pe cele ale angajatilor.
        </p>

        <p className="mb-4">
          Am construit, de-a lungul timpului, o echipa entuziasta si
          profesionista, pentru a oferi clientilor nostri cele mai bune oferte
          si o experienta de cumparare de calitate.
        </p>
      </>
    )}

    {websiteName === "mediagalaxy" && (
      <>
        <div className="mb-10">
          <p>
            Conceptul omnichannel pe care Media Galaxy il propune, le ofera
            clientilor posibilitatea de a achizitiona atat online, cat si
            offline, produse de calitate adecvate nevoilor tuturor tipurilor de
            consumatori.
          </p>

          <p>
            In present ne desfasuram activitatea intr-un mediu dinamic, cu focus
            atat pe nevoile clientilor, cat si pe nevoile angajatilor.
          </p>

          <p>
            Am construit, de-a lungul timpului o echipa dinamica si
            profesionista pentru a oferi clientilor nostri cele mai noi produse,
            o gama cat mai variata si o experienta de cumparare de calitate.
          </p>
        </div>
      </>
    )}

    {websiteName !== "bricostore" && (
      <div className="mt-6">
        <Heading
          as="h2"
          display="h2"
          title={`Misiunea noastra`}
          classesProp="mb-4"
        />
        <p className="mb-4">
          Principala misiune este aceea de a face noile tehnologii si
          echipamente accesibile tuturor clientilor, reusind astfel sa
          imbunatatim confortul vietii cotidiene nu doar prin produsele oferite,
          ci si prin varietatea de servicii pe care o punem la dispozitie:
          service, transport, extragarantii, asigurari.
        </p>
      </div>
    )}

    <div className="mt-6">
      <Heading as="h2" display="h2" title={`Valori`} classesProp="mb-4" />
      <p className="mb-4">
        Valorile companiei sunt factorul care genereaza unitatea echipelor,
        asigura continuitate business-ului si creeaza o cultura organizationala
        in care angajatii se pot dezvolta professional.
      </p>
      <p className="mb-4">
        Principalele valori: Integritate, Moralitate, Autentiticate, Agilitate
        si Energie
      </p>
    </div>

    <div className="mt-6">
      <Heading
        as="h2"
        display="h2"
        title={`Ce inseamna o cariera la ${websiteTitle}?`}
        classesProp="mb-4"
      />
      <p className="mb-4">
        Te gandesti sa incepi o cariera de succes in retail?
      </p>
      <p className="mb-4">
        Consideri ca e firesc sa pui clientul pe primul loc si vrei sa lucrezi
        intr-o echipa care se axeaza pe comunicare, inovatie si tehnologie?
      </p>
      <p className="mb-4">
        E momentul sa arunci un ochi asupra locurilor de munca disponibile in{" "}
        {websiteTitle} – ai sansa sa gasesti dintr-o privire ceea ce ti se
        potriveste cel mai bine.
      </p>
      <p className="mb-4">
        Suntem in cautarea unor colegi entuziasti, axati pe dezvoltare
        profesionala si orientati spre performanta.
      </p>
      <p className="mb-4">
        Esti pasionat de{" "}
        {websiteName !== "bricostore" ? "TEHNOLOGIE" : "BRICOLAJ"}? Te asteptam
        in echipa {websiteTitle}!
      </p>
      <p className="mb-4">
        Tot ce ai de facut pentru a fi cu un pas mai aproape de jobul potrivit
        este sa verifici, chiar aici, in ce orase sunt locuri de munca
        disponibile si pe ce pozitii se fac angajari, astfel incat sa te
        orientezi catre o zona compatibila cu experienta pe care o ai si cu
        pasiunile tale.
      </p>
    </div>

    <div className="mt-6">
      <Heading
        as="h2"
        display="h2"
        title={`La ${websiteTitle} ai posibilitatea de a te angaja in:`}
        classesProp="mb-4"
      />
      <ul className="list-disc ml-5 mb-4">
        <li>
          <strong>Magazine</strong> – posturile sunt potrivite tuturor
          persoanelor proactive, care iubesc sa interactioneze direct cu
          clientul si isi doresc sa ii ofere acestuia o experienta omnichannel;
        </li>

        <li>
          <strong>Sediul central din Bucuresti</strong> – ofera posibilitatea de
          o lucra in diverse departamente, iar activitatile presupun experienta
          in domeniu, spirit de initiativa, responsabilitate;
        </li>

        {websiteName !== "bricostore" && (
          <li>
            <strong>Depozit</strong> – posturile sunt preferate, in general, de
            persoanele foarte bine organizate si meticuloase, ce isi doresc sa
            contribuie la imbunatatirea experientei de livrare a produselor
            catre client;
          </li>
        )}
      </ul>
      <p className="mb-4">
        Odata ce ai vazut postul care te intereseaza, este de ajuns sa trimiti
        CV-ul si sa astepti ulterior sa fii contactat de catre departamentul de
        Resurse Umane. In cadrul interviului vei avea ocazia sa discuti mai
        multe despre responsabilitatile, beneficiile si salariul de la{" "}
        {websiteTitle}.
      </p>
    </div>
  </div>
);

const footerContent = (
  <div className="mt-6">
    <Heading
      as="h2"
      display="h2"
      // TODO Check title for bricostore
      title={`De ce au ales actualii angajati sa se alature ${
        websiteName === "altex" ? "grupului Altex" : "echipei noastre"
      }?`}
      classesProp="text-red-brand mb-4"
    />
    <ul className="list-disc ml-5 mb-4">
      <li>Dorinta de a se alatura unui brand romanesc cu traditie;</li>
      <li>Buna relationare cu brandul prin prisma experientei de client;</li>
      <li>Diversitatea liniilor de business;</li>
      <li>Oportunitati de dezvoltare profesionala;</li>
      <li>Posibilitatea de a lucra cu cele mai noi tehnologii;</li>
      <li>Posibilitatea de a invata lucruri noi;</li>
      <li>
        Sansa de a lucra intr-un mediu deschis si prietenos, in care te
        integrezi usor.
      </li>
    </ul>
  </div>
);

export const content = {
  altex: {
    title: "Indrazneste si vino alaturi de cei mai buni",
    image: [
      {
        path: `${websiteStatics}/images/about-us/about-us-mobile.svg`,
        media: "(max-width: 640px)",
        isDefault: false,
      },
      {
        path: `${websiteStatics}/images/about-us/about-us.svg`,
        isDefault: true,
      },
    ],
    mainContent: mainContent,
    footerContent: footerContent,
  },
  mediagalaxy: {
    title: "Indrazneste si vino alaturi de cei mai buni",
    image: [
      {
        path: `${cdn}/LP/MGX/cariere-mediagalaxy/LP_BannerTop_320x160_c6f4c4e6.png`,
        media: "(max-width: 320px)",
        isDefault: false,
      },
      {
        path: `${cdn}/LP/MGX/cariere-mediagalaxy/LP_BannerTop_640x230_e616d7a2.png`,
        media: "(max-width: 640px)",
        isDefault: false,
      },
      {
        path: `${cdn}/LP/MGX/cariere-mediagalaxy/LP_BannerTop_1000x300_a133a0f8.png`,
        media: "(max-width: 1000px)",
        isDefault: false,
      },
      {
        path: `${cdn}/LP/MGX/cariere-mediagalaxy/LP_BannerTop_1000x300_a133a0f8.png`,
        isDefault: true,
      },
    ],
    mainContent: mainContent,
    footerContent: footerContent,
  },
  // TODO update this content when bricostore will have a new design
  bricostore: {
    title: "Indrazneste si vino alaturi de cei mai buni",
    image: [
      {
        path: `${websiteStatics}/images/about-us/about-us-mobile.svg`,
        media: "(max-width: 640px)",
        isDefault: false,
      },
      {
        path: `${websiteStatics}/images/about-us/about-us.svg`,
        isDefault: true,
      },
    ],
    mainContent: mainContent,
    footerContent: footerContent,
  },
};
